/**
 * flats-showcase.js — витрина квартир: фильтр в одну строку, строка итога с
 * четырьмя видами показа, вид «Сводка» и переработанный текст карточки.
 * Перенос черновика `tools/.hero-draft/zadacha-kvartiry.*` (дизайн 20.08.2026).
 *
 * Пара к public/css/flats-showcase.css. Обе записи — в public/flats.php
 * ($pageCSS и $pageJS); откат блока = снятие этих двух строк.
 *
 * Что делает (адреса `/novostroyki/{город}/kvartiry/` и
 * `/novostroyki/{город}/zhk-{слаг}/kvartiry/`):
 *   КВ-1  городская витрина: фото шапки убрано, плитки цифр свёрнуты в строку
 *         (сами числа — ЖИВЫЕ узлы, их по-прежнему пишет flats.js);
 *   КВ-2  фильтр = одна строка (город · ЖК · комнатность · цена) + кнопка
 *         «Ещё фильтры»; на компьютере она раскрывается ВО ВЕСЬ ЭКРАН с
 *         крестиком сверху (прямое требование владельца 20.08), на телефоне
 *         фильтр — полноэкранная шторка;
 *   КВ-5  четвёртый вид «Сводка» — разбивка по комнатности с планировками;
 *   КВ-6  строка параметров карточки «67,1 м² · 2-комн. · 24/45 эт.»;
 *   КВ-7  цена крупнее заголовка, ₽/м² рядом мелким;
 *   КВ-8  ряд чипов комнатности под H1 (сейчас погашен стилем — владелец
 *         20.08 «убери дубли»; узлы оставлены, см. flats-showcase.css);
 *   КВ-9  строка итога «Найдено N квартир» + сортировка + четыре вкладки.
 *
 * ⛔ УЗЛЫ САЙТА ПЕРЕНОСИМ, А НЕ КОПИРУЕМ. Все контролы фильтра уже подписаны
 *    flats.js ПОИМЁННО (по id). Копия выглядела бы так же и не фильтровала бы
 *    ничего, а скопированный id увёл бы чужие обработчики на мёртвый узел.
 *
 * ⛔ ПОРЯДОК ЗАПУСКА. Файл стоит в $pageJS ПЕРЕД /js/flats.js и потому
 *    перехватывает fetch раньше, чем витрина сделает первый запрос: без этого
 *    ответ первого `action=list` прошёл бы мимо и «Сводка» осталась бы без
 *    отпечатка фильтра. Перестановка узлов идёт по DOMContentLoaded — то есть
 *    уже ПОСЛЕ того, как flats.js навесил обработчики.
 *    ⛔ Проверять readyState здесь НЕЛЬЗЯ «как обычно»: во время исполнения
 *    defer-скрипта он уже 'interactive', и наивное `readyState !== 'loading'
 *    → выполнить сейчас` собрало бы фильтр ДО flats.js. Ждём событие всегда,
 *    кроме случая 'complete' (скрипт подмешали в уже загруженную страницу).
 *
 * ⛔ ДОГОВОР СО СТИЛЕМ: ДО СБОРКИ СТРАНИЦА НЕПОЛНАЯ. flats-showcase.css гасит
 *    (visibility) секцию города, фильтр, строку итога и карточки — иначе они
 *    рисуются в родных местах, а сборка их переставляет, и получается прыжок
 *    раскладки. Отсюда две обязанности этого файла:
 *      • по успеху — `zkv-ready` на <html>;
 *      • по любому сбою — `zkv-broken` на <html> (родная раскладка назад).
 *    Стиль вдобавок подстрахован таймером: страница появится, даже если этот
 *    файл не исполнится вовсе.
 *
 * ⛔ РАЗЛИЧИЕ «ТЕЛЕФОН / КОМПЬЮТЕР» ЖИВЁТ ТОЛЬКО В @media. Проверок ширины в
 *    скрипте нет ни одной сознательно: альбом крупного телефона (405×928 →
 *    928 px) ШИРЕ порога 900, и решение, принятое один раз при загрузке, стало
 *    бы односторонней дверью — открытая в альбоме страница не получила бы
 *    своего вида никогда. Поворот обратим сам, обеими сторонами.
 *
 * ⛔ ЧЕГО ЗДЕСЬ НЕТ И ПОЧЕМУ.
 *    • Подмены обложки карточки квартиры. Прод уже вписывает план целиком
 *      (object-fit:contain, 340 px) — кроп чертежа срезает углы с балконом,
 *      санузлом и подписями площадей.
 *    • Второго блока черновика, который переписывал src у ВСЕХ картинок
 *      карточек на /img-thumb.php. Это костыль стенда (системный прокси не
 *      поднят, картинки застройщика не грузились) и одновременно смена
 *      поведения прода для чужих узлов — решение владельца, не наше. Наши
 *      собственные плитки планировок через уменьшитель идут (см. thumbUrl).
 *    • Чисел дома в шапке страницы ЖК: их правит соседний черновик
 *      `zadacha-zhk-kv-verh`, здесь шапка ЖК не трогается вовсе.
 */
(() => {
  'use strict';

  // Повторный запуск (второе подмешивание, горячая перезагрузка) — выходим.
  if (window.__broniFlatsShowcase) return;
  const grid = document.getElementById('flatsGrid');
  const html = document.documentElement;
  if (!grid) {
    // Не витрина квартир (или разметка изменилась) — снимаем маскировку стиля,
    // чтобы страница не осталась невидимой из-за нашего договора.
    html.classList.add('zkv-broken');
    return;
  }
  window.__broniFlatsShowcase = true;

  // Витрина ОДНОГО ЖК: сервер печатает id дома в <head>. Пусто = городская
  // витрина «просто квартиры города» — там по КВ-1 снимаем фото шапки.
  const IS_JK_PAGE = String(window.BRONI_FLATS_BUILDING_ID || '') !== '';

  // ⛔ МЕТКА ГОРОДСКОЙ ВИТРИНЫ СТАВИТСЯ СРАЗУ, А НЕ В КОНЦЕ СБОРКИ. По ней
  // стиль гасит плитки цифр; поставь мы её вместе с остальным — плитки успели
  // бы отрисоваться и схлопнуться на глазах. Обратный порядок (гасить всегда,
  // возвращать на странице ЖК) хуже: при сбое скрипта витрина дома осталась бы
  // без чисел вовсе.
  if (!IS_JK_PAGE) document.body.classList.add('zkv-city');

  const noop = () => {};
  const nf = new Intl.NumberFormat('ru-RU');

  /** Узел с классом и текстом — тот же помощник, что у фильтра карточки ЖК. */
  function el(tag, cls, text) {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }

  function icon(cls, extra) {
    // ⛔ classList.add('a b') бросает исключение — пробел в токене недопустим,
    // и весь скрипт умирал бы на первой иконке. Собираем строкой класса.
    const i = document.createElement('i');
    i.className = cls + (extra ? ' ' + extra : '');
    i.setAttribute('aria-hidden', 'true');
    return i;
  }

  function pluralRu(n, one, few, many) {
    const a = Math.abs(n) % 100;
    const b = a % 10;
    if (a > 10 && a < 20) return many;
    if (b > 1 && b < 5) return few;
    if (b === 1) return one;
    return many;
  }

  const flatsWord = (n) => pluralRu(n, 'квартира', 'квартиры', 'квартир');
  const plansWord = (n) => pluralRu(n, 'планировка', 'планировки', 'планировок');

  /* ──────────────────────────────────────────────────────────────────────────
     1. ПЕРЕХВАТ ОТВЕТОВ /flat_api.php
     Этаж квартиры приходит в JSON и в разметку попадает только слитым текстом
     подвала. Слушаем ответ, а не выдумываем второй запрос: лишний запрос —
     это ещё и второй источник правды.

     ⛔ ЗДЕСЬ ЖЕ РОЖДАЕТСЯ ОТПЕЧАТОК ФИЛЬТРА ДЛЯ «СВОДКИ». Собственного
     collectFilters() у нас нет и быть не должно: он жил бы отдельно от
     flats.js и разошёлся бы с ним на первом же новом фильтре. Мы забираем
     СЫРУЮ строку запроса, которую flats.js только что отправил, — это ровно
     тот набор фильтров, что сейчас на экране, без второго толкования.
     ────────────────────────────────────────────────────────────────────────── */
  const flatById = new Map();
  const nativeFetch = window.fetch ? window.fetch.bind(window) : null;

  let baseQuery = '';        // сырая строка запроса последнего action=list
  let lastPlansCount = null; // сколько планировок в текущей выдаче (view=plans)
  let lastViewPlans = false;

  /* ⛔ ВЫДАЧА ВИТРИНЫ — ТОЛЬКО ЗАПРОСЫ flats.js, У НИХ ВСЕГДА ЕСТЬ `city=` (collectFilters).
     С 27.09.2026 вкладка «Планировки» витрины дома — блок карточки ЖК (js/jk-filter.js,
     js/flats-plans-view.js): он ходит в тот же action=list, но без города. Прими мы его
     ответ за выдачу витрины — «Сводка» взяла бы его отпечаток фильтра, а панель квартир
     планировки (тоже action=list) подменила бы «Найдено». Числа вкладки приходят отдельным
     событием `broni:flats-plans-found` (ниже). */
  const showcaseList = (url) => url.indexOf('action=list') !== -1 && /[?&]city=/.test(url);

  if (nativeFetch) {
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : ((input && input.url) || '');
      const promise = nativeFetch(input, init);
      if (url.indexOf('/flat_api.php') !== -1) {
        if (showcaseList(url)) rememberQuery(url);
        promise.then((res) => {
          // clone() обязателен: тело читается один раз, оригинал нужен flats.js.
          try {
            res.clone().json().then((data) => {
              if (url.indexOf('action=filter_options') !== -1) rememberOptions(data);
              else if (showcaseList(url)) rememberList(data);
            }).catch(noop);
          } catch (e) { noop(); }
        }).catch(noop);
      }
      return promise;
    };
  }

  // Вкладка «Планировки» витрины дома: «Найдено N планировок · M квартир», как у прежнего
  // вида. Плитка по возврату пришлёт свой ответ (rememberList) и вернёт «квартир».
  document.addEventListener('broni:flats-plans-found', (e) => {
    const d = (e && e.detail) || {};
    lastViewPlans = true;
    lastPlansCount = typeof d.plans === 'number' ? d.plans : null;
    refreshFound();
  });

  function rememberQuery(url) {
    baseQuery = url.slice(url.indexOf('?') + 1);
    scheduleSummary();
  }

  function rememberList(data) {
    if (!data || !data.ok) return;
    lastViewPlans = data.view === 'plans';
    lastPlansCount = lastViewPlans && typeof data.plans === 'number' ? data.plans : null;
    refreshFound();
    if (Array.isArray(data.flats)) {
      data.flats.forEach((f) => {
        if (f && f.id !== null && f.id !== undefined) flatById.set(String(f.id), f);
      });
      decorateAll();
    }
  }

  /* ──────────────────────────────────────────────────────────────────────────
     2. КАРТОЧКА КВАРТИРЫ (КВ-6 + КВ-7)

     ⛔ ОБЛОЖКУ НЕ ТРОГАЕМ. Прод уже делает то же, что Домклик и Яндекс: план
     вписан целиком (object-fit:contain) на светлой панели, 340px. Кроп чертежа
     срезает углы с балконом, санузлом и подписями площадей. Ни одной строки
     про .flat-card-image здесь нет — это намеренно.

     Меняем ТОЛЬКО текст под планом:
       название ЖК → «67,1 м² · 2-комн. · 24/45 эт.» → ЦЕНА крупно + ₽/м² мелким
     ────────────────────────────────────────────────────────────────────────── */
  function flatIdOf(card) {
    const m = /[?&]id=(\d+)/.exec(card.getAttribute('href') || '');
    return m ? m[1] : '';
  }

  const tsep = () => el('span', 'zkv-tsep', '·');

  /** Позиция прямого ребёнка карточки. ⛔ Через индексы, а не через
      Node.DOCUMENT_POSITION_*: глобал `Node` не объявлен в конфиге ESLint
      сайтового кода, и файл падал бы линтом на ровном месте. */
  const childIndex = (parent, node) => Array.prototype.indexOf.call(parent.children, node);

  /* КВ-6: параметры одной строкой, площадь первой. Она различает лоты сильнее
     слова «двухкомнатная» — так делает Яндекс, и на витрине КВАРТИР это верно
     (на витрине ЖК было бы наоборот). */
  function relayoutCard(card) {
    if (card.dataset.zkvText === '1') return;
    const wrap = card.querySelector('.flat-card-img-wrap');
    const head = card.querySelector('.flat-card-head');
    const body = card.querySelector('.flat-card-body');
    const row = card.querySelector('.flat-card-row');
    if (!body || !row) return;
    card.dataset.zkvText = '1';
    card.classList.add('zkv-card');

    // План — первым, название ЖК уходит ПОД него (принятое решение владельца).
    if (wrap && head && wrap.parentNode === card && head.parentNode === card
        && childIndex(card, head) < childIndex(card, wrap)) {
      card.insertBefore(wrap, head);
    }

    // Строка параметров: площадь · тип · этаж. Узлы ПЕРЕНОСИМ из тех мест, где
    // они лежали (шапка и строка цены), а не создаём копии.
    const line = el('div', 'zkv-titleline');
    const area = card.querySelector('.flat-card-area');
    const tag = card.querySelector('.flat-card-tag');
    if (area) line.appendChild(area);
    if (tag) {
      if (line.firstChild) line.appendChild(tsep());
      line.appendChild(tag);
    }
    body.insertBefore(line, body.firstChild);

    // КВ-7: ₽/м² встаёт РЯДОМ с ценой, а не строкой ниже. Бейдж скидки уже
    // внутри обёртки цены, поэтому дописываем в конец — порядок выходит
    // «цена · −7% · 118 000 ₽/м²».
    const price = card.querySelector('.flat-card-price');
    const m2 = card.querySelector('.flat-card-m2');
    if (price && m2 && price.parentNode) price.parentNode.appendChild(m2);
  }

  /** Этаж «24/45 эт.». Первый источник — данные API (те же, из которых
      flats.js собрал карточку). Запасной — текст подвала карточки. */
  function floorText(card) {
    const f = flatById.get(flatIdOf(card));
    if (f && f.floor) {
      return String(f.floor) + (f.floors_total ? '/' + String(f.floors_total) : '') + ' эт.';
    }
    const meta = card.querySelector('.flat-card-meta');
    const m = meta ? /(\d+(?:\/\d+)?)\s*эт\./.exec(meta.textContent || '') : null;
    return m ? m[1] + ' эт.' : '';
  }

  /* ⛔ ЭТАЖ ИЗ ПОДВАЛА УБИРАЕМ, а не оставляем вторым экземпляром: одно и то же
     число дважды в одной карточке читается как ошибка вёрстки. Подвал —
     слитая строка «Апартаменты · 24/45 эт. · Краснодар · …», поэтому режем
     ровно свой кусок в текстовом узле и подчищаем осиротевший разделитель. */
  function stripFloorFromMeta(card) {
    const meta = card.querySelector('.flat-card-meta');
    if (!meta) return;
    Array.prototype.forEach.call(meta.childNodes, (n) => {
      if (n.nodeType !== 3) return;
      const t = n.nodeValue;
      if (!/\d\s*эт\./.test(t)) return;
      // ⛔ КРАЕВОЙ РАЗДЕЛИТЕЛЬ СНИМАЕМ, ТОЛЬКО ЕСЛИ С ЭТОЙ СТОРОНЫ НИЧЕГО НЕТ.
      // Резали безусловно — и подвал склеивался в «АпартаментыКраснодар…»:
      // соседи здесь ЭЛЕМЕНТЫ («Апартаменты», «Предчистовая»), а точка между
      // ними живёт в НАШЕМ текстовом узле. Убрав её, мы убирали чужой стык.
      let out = t
        .replace(/\d+(?:\/\d+)?\s*эт\./, '')
        .replace(/\s*·\s*·\s*/g, ' · ');
      if (!n.previousSibling) out = out.replace(/^\s*·\s*/, '');
      if (!n.nextSibling) out = out.replace(/\s*·\s*$/, '');
      n.nodeValue = out.replace(/\s{2,}/g, ' ');
    });
  }

  function fillFloor(card) {
    if (card.dataset.zkvFloor === '1') return;
    const line = card.querySelector('.zkv-titleline');
    if (!line) return;
    const txt = floorText(card);
    if (!txt) return;                 // данных ещё нет — вернёмся следующим проходом
    card.dataset.zkvFloor = '1';
    if (line.firstChild) line.appendChild(tsep());
    line.appendChild(el('span', 'zkv-floor', txt));
    stripFloorFromMeta(card);
  }

  function decorateAll() {
    const cards = grid.querySelectorAll('a.flat-card');
    Array.prototype.forEach.call(cards, (card) => {
      relayoutCard(card);
      fillFloor(card);
    });
  }

  /* Выдача дорисовывается по «Показать ещё» и по страницам — наблюдаем за
     гридом, иначе новая раскладка досталась бы только первым 24 карточкам.
     ⛔ Наблюдатель смотрит на childList грида, а пишет ВНУТРЬ карточек и под
     флагами dataset — повторно ту же карточку не трогает, петли нет. */
  if (window.MutationObserver) {
    new MutationObserver(() => decorateAll()).observe(grid, { childList: true });
  }

  /* ──────────────────────────────────────────────────────────────────────────
     3. КВ-2: ФИЛЬТР — ОДНА СТРОКА + «ЕЩЁ ФИЛЬТРЫ»
     ────────────────────────────────────────────────────────────────────────── */
  let mstripText = null;
  let mstripCount = null;
  let foundNode = null;
  let moreBox = null;
  let moreBtn = null;
  let moreNum = null;
  let resetBtn = null;

  function groupOf(root, sel) {
    const node = root.querySelector(sel);
    return node ? node.closest('.flats-filter-group') : null;
  }

  function relabel(group, text) {
    if (!group) return;
    const lbl = group.querySelector('.flats-filter-label');
    if (lbl) lbl.textContent = text;
  }

  function buildFilterRow() {
    const section = document.querySelector('.flats-filters-section');
    const filters = document.getElementById('flatsFilters');
    if (!section || !filters || section.classList.contains('zkv-bar-section')) return;
    const container = section.querySelector('.container') || section;

    section.classList.add('zkv-bar-section');
    filters.classList.add('zkv-panel');

    // ── Снаружи: город · ЖК · комнатность · цена. Ровно то, что снаружи у всех
    //    четырёх площадок. ⛔ Комнатность и цену под «Ещё» не прячем ни в коем
    //    случае: это два поля, ради которых страницу открывают.
    const quick = el('div', 'zkv-quick');

    const cityBtn = document.getElementById('flatsCityFilter');
    let cityGroup = null;
    if (cityBtn) {
      const citySection = cityBtn.closest('.flats-city-section');
      cityGroup = el('div', 'flats-filter-group');
      cityGroup.appendChild(el('label', 'flats-filter-label', 'Город'));
      cityGroup.appendChild(cityBtn);
      if (citySection) citySection.classList.add('zkv-city-section-empty');
    }

    const jkGroup = groupOf(filters, '#filterBuilding');
    relabel(jkGroup, 'Жилой комплекс');
    const roomsGroup = groupOf(filters, '#roomsBtns');
    relabel(roomsGroup, 'Комнатность');
    const priceGroup = groupOf(filters, '#priceMin');
    relabel(priceGroup, 'Цена, ₽');
    if (priceGroup) {
      priceGroup.classList.add('zkv-pricebox');
      // Один и тот же узел подписи: в строке он стоит слева от полей, в шторке
      // на телефоне — сверху. Вторая подпись с тем же словом была бы двумя
      // источниками одного смысла в соседних строках разметки.
      const lbl = priceGroup.querySelector('.flats-filter-label');
      if (lbl) lbl.classList.add('zkv-inline-lbl');
    }

    // ── Под «Ещё»: срок сдачи → отделка → предложения → площадь → этаж.
    const more = el('div', 'zkv-more');
    more.id = 'zkvMore';

    // ⛔ ШАПКА С КРЕСТИКОМ — ТРЕБОВАНИЕ ВЛАДЕЛЬЦА (20.08): расширенный фильтр
    //    на компьютере раскрывается во весь экран, и окно без явной кнопки
    //    закрытия оставляет человека гадать, чем его убрать. Клик мимо и Escape
    //    работали и раньше, но невидимый выход — не выход.
    //    Шапку строим ВСЕГДА, а показываем только на компьютере (CSS): на
    //    телефоне у шторки уже есть своя, и вторая была бы дублем. Строить её
    //    «по ширине» нельзя — поворот телефона пересекает порог 900.
    const moreHead = el('div', 'zkv-more__head');
    moreHead.appendChild(el('span', 'zkv-more__title', 'Расширенный фильтр'));
    const moreClose = el('button', 'zkv-more__close');
    moreClose.type = 'button';
    moreClose.setAttribute('aria-label', 'Закрыть расширенный фильтр');
    moreClose.appendChild(icon('fas fa-xmark'));
    moreClose.addEventListener('click', (e) => { e.stopPropagation(); setMore(false); });
    moreHead.appendChild(moreClose);
    more.appendChild(moreHead);

    const moreGrid = el('div', 'zkv-more__grid');

    const deadlineGroup = groupOf(filters, '#filterDeadline');
    relabel(deadlineGroup, 'Срок сдачи');
    const finishGroup = groupOf(filters, '#kindBtns') || groupOf(filters, '#renovationBtns');
    relabel(finishGroup, 'Отделка');
    const areaGroup = groupOf(filters, '#areaMin');
    relabel(areaGroup, 'Площадь, м²');
    const floorGroup = groupOf(filters, '#floorMin');
    relabel(floorGroup, 'Этаж');

    // «Скидка» и «Рассрочка» жили в панели сортировки, где читались как
    // украшение. Это фильтры — им место в фильтре.
    const offers = el('div', 'flats-filter-group');
    offers.appendChild(el('span', 'zkv-lbl', 'Предложения'));
    const chips = el('div', 'zkv-chips');
    ['flatsDiscountChip', 'flatsInstallmentChip'].forEach((id) => {
      const c = document.getElementById(id);
      if (c) chips.appendChild(c);
    });
    offers.appendChild(chips);

    // ⛔ ПОРЯДОК СОБИРАЕМ ТОЛЬКО appendChild'ом, БЕЗ ОПОРНЫХ УЗЛОВ.
    // insertBefore(x, anchor) падал бы с NotFoundError: опорным узлом
    // оказывалась та самая группа, которую предыдущей строкой уже унесли.
    if (deadlineGroup) moreGrid.appendChild(deadlineGroup);
    if (finishGroup) moreGrid.appendChild(finishGroup);
    if (chips.childNodes.length) moreGrid.appendChild(offers);
    if (areaGroup) moreGrid.appendChild(areaGroup);
    if (floorGroup) moreGrid.appendChild(floorGroup);
    more.appendChild(moreGrid);

    const actions = filters.querySelector('.flats-filter-actions');
    resetBtn = document.getElementById('flatsReset');
    if (actions) {
      actions.className = 'zkv-more__foot';   // прод-класс группы здесь мешает
      more.appendChild(actions);
    }

    // Кнопка «Ещё фильтры» со счётчиком выбранного.
    moreBtn = el('button', 'zkv-morebtn');
    moreBtn.type = 'button';
    moreBtn.setAttribute('aria-expanded', 'false');
    moreBtn.setAttribute('aria-controls', 'zkvMore');
    moreBtn.appendChild(icon('fas fa-sliders-h'));
    moreBtn.appendChild(el('span', 'zkv-morebtn__l', 'Ещё фильтры'));
    moreNum = el('span', 'zkv-morebtn__n', '');
    moreBtn.appendChild(moreNum);

    if (cityGroup) quick.appendChild(cityGroup);
    if (jkGroup) quick.appendChild(jkGroup);
    if (roomsGroup) quick.appendChild(roomsGroup);
    if (priceGroup) quick.appendChild(priceGroup);
    // «Метро и районы» (27.09.2026) — сразу после цены. Группу строит js/flats-geo.js
    // (он подключён раньше нас); её нет — на витрине одного ЖК и без скрипта окна.
    const geoGroup = document.getElementById('nvMetroTrigger');
    if (geoGroup) quick.appendChild(geoGroup);
    // ⛔ ДВЕ КНОПКИ — ОДИН УЗЕЛ. Порознь они переносились порознь: при ширине
    //    1294 ряд не помещался, и «Сбросить» уезжал на вторую строку — причём
    //    в её НАЧАЛО, под «Город». Наложения по числам не было, а на глаз
    //    кнопка выглядела отвалившейся. В общей обёртке пара переносится
    //    целиком и остаётся справа.
    const actionsPair = el('div', 'zkv-actions');
    actionsPair.appendChild(moreBtn);
    if (resetBtn) actionsPair.appendChild(resetBtn);   // перенос: обработчик flats.js цел
    quick.appendChild(actionsPair);

    filters.appendChild(quick);
    filters.appendChild(more);
    moreBox = more;

    // Шапка шторки (видна только на телефоне).
    const sheetHead = el('div', 'zkv-sheet-head');
    sheetHead.appendChild(el('span', 'zkv-sheet-title', 'Фильтры'));
    const close = el('button', 'zkv-sheet-close');
    close.type = 'button';
    close.setAttribute('aria-label', 'Закрыть фильтр');
    close.appendChild(icon('fas fa-times'));
    sheetHead.appendChild(close);
    container.insertBefore(sheetHead, filters);
    close.addEventListener('click', () => closeSheet());

    buildMobileStrip(section);
    bindPanel(filters);
    refreshLabels();
  }

  /* Планка-сводка для телефона: что сейчас отобрано + сколько нашлось.
     ⛔ ЭТО СОХРАНЁННОЕ ОТЛИЧИЕ ВИТРИНЫ. На 390px в строку не помещаются даже
     четыре «быстрых» контрола. */
  function buildMobileStrip(section) {
    const strip = el('div', 'zkv-mstrip');
    const btn = el('button', 'zkv-mstrip__btn');
    btn.type = 'button';
    btn.setAttribute('aria-expanded', 'false');
    btn.appendChild(icon('fas fa-sliders-h', 'zkv-mstrip__ico'));

    mstripText = el('span', 'zkv-mstrip__txt', 'Все квартиры');
    mstripCount = el('span', 'zkv-mstrip__cnt');
    btn.appendChild(mstripText);
    btn.appendChild(mstripCount);
    strip.appendChild(btn);

    section.parentNode.insertBefore(strip, section);
    btn.addEventListener('click', () => openSheet(section, btn));

    // Число «нашлось» пишет flats.js в #flatsCount — следим за ним, иначе
    // планка показывала бы цифру на момент открытия страницы.
    // ⛔ Наблюдатель смотрит на ЧУЖОЙ узел и пишет в СВОИ — петли нет.
    const cnt = document.getElementById('flatsCount');
    if (cnt && window.MutationObserver) {
      new MutationObserver(() => refreshFound())
        .observe(cnt, { childList: true, characterData: true, subtree: true });
    }
    refreshFound();
  }

  function openSheet(section, btn) {
    section.classList.add('zkv-open');
    document.body.classList.add('zkv-sheet-lock');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function closeSheet() {
    const section = document.querySelector('.flats-filters-section');
    if (section) section.classList.remove('zkv-open');
    document.body.classList.remove('zkv-sheet-lock');
    const btn = document.querySelector('.zkv-mstrip__btn');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function setMore(open) {
    if (!moreBox || !moreBtn) return;
    moreBox.classList.toggle('is-open', open);
    moreBtn.classList.toggle('is-open', open);
    moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    // ⛔ Блокировки прокрутки фона здесь НЕТ намеренно. `overflow:hidden` на
    // компьютере убирает полосу прокрутки, а вместе с ней страница прыгает на
    // её ширину — при закрытии окна прыгает обратно. На телефоне фон запирает
    // шторка своим классом, и там полосы нет.
  }

  function bindPanel(filters) {
    const later = () => window.setTimeout(refreshLabels, 0);
    filters.addEventListener('click', later);
    filters.addEventListener('input', later);
    filters.addEventListener('change', later);
    document.addEventListener('project-change', later);
    // Состояние сменилось ВНЕ панели фильтра — корпус на генплане, «Назад» по истории:
    // flats.js сообщает об этом в начале каждой загрузки выдачи.
    document.addEventListener('broni:flats-corpus-change', later);
    // «Метро и районы» применили в своём окне — оно вне панели фильтра.
    document.addEventListener('broni:flats-geo-change', later);

    if (moreBtn) {
      moreBtn.addEventListener('click', () => setMore(!moreBox.classList.contains('is-open')));
    }
    // Клик мимо панели закрывает её — иначе раскрытая панель висит поверх
    // выдачи и человек не понимает, чем её убрать.
    document.addEventListener('click', (e) => {
      if (!moreBox || !moreBox.classList.contains('is-open')) return;
      if (e.target.closest('.zkv-more') || e.target.closest('.zkv-morebtn')) return;
      setMore(false);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      setMore(false);
      closeSheet();
    });

    // «Показать N квартир» закрывает и панель, и шторку.
    const apply = document.getElementById('flatsApply');
    if (apply) apply.addEventListener('click', () => { setMore(false); closeSheet(); });
  }

  /* ── Подписи, счётчик «Ещё» и текст планки-сводки ────────────────────────
     Свёрнутый фильтр обязан показывать, чем сейчас урезана выдача: иначе
     пользователь видит «мало квартир» и не понимает, почему.                */
  const ROOM_NAMES = { '': '', 0: 'Студия', 1: '1к', 2: '2к', 3: '3к', 4: '4к+' };
  const STRIP_KEYS = ['rooms', 'price', 'area', 'floor', 'deadline', 'kind', 'renovation'];
  // Что уехало под кнопку «Ещё» — из этого и складывается её счётчик.
  const MORE_KEYS = ['deadline', 'area', 'floor', 'kind', 'renovation'];

  function val(id) {
    const node = document.getElementById(id);
    return node && node.value ? String(node.value).trim() : '';
  }

  function mln(v) {
    const n = parseFloat(v);
    if (!isFinite(n) || n <= 0) return '';
    return (n / 1000000).toFixed(1).replace(/\.0$/, '') + ' млн';
  }

  function range(minRaw, maxRaw, fmt, unit) {
    const a = minRaw ? (fmt ? fmt(minRaw) : minRaw) : '';
    const b = maxRaw ? (fmt ? fmt(maxRaw) : maxRaw) : '';
    const tail = unit ? ' ' + unit : '';
    if (a && b) return a + '–' + b + tail;
    if (a) return 'от ' + a + tail;
    if (b) return 'до ' + b + tail;
    return '';
  }

  /** Подпись чипа без его счётчика: «Предчистовая 14373» → «Предчистовая». */
  function chipText(node) {
    if (!node) return '';
    const cnt = node.querySelector('span');
    const raw = cnt ? node.textContent.replace(cnt.textContent, '') : node.textContent;
    return raw.trim();
  }

  /* ⛔ АКТИВНЫЙ ЧИП ИЩЕМ ПЕРЕБОРОМ, А НЕ ПЕРВЫМ СОВПАДЕНИЕМ.
     В каждом ряду первым стоит чип «Все» / «Любая» с ПУСТЫМ data-атрибутом, и
     querySelector('.active') возвращал именно его, если из-за рассинхрона класс
     «active» повис на двоих. Тогда выбранная «Предчистовая» молча не попадала
     ни в счётчик «Ещё фильтры», ни в планку телефона — фильтр был включён, а
     человеку показывали «ничего не выбрано». Перебор берёт чип со ЗНАЧЕНИЕМ. */
  function activeChip(sel, attr) {
    const list = document.querySelectorAll(sel);
    for (let i = 0; i < list.length; i++) {
      const n = list[i];
      if (n.classList.contains('active') && (n.dataset[attr] || '') !== '') return n;
    }
    return null;
  }

  function summaryOf(key) {
    switch (key) {
      case 'rooms': {
        const b = activeChip('#roomsBtns .room-btn', 'rooms');
        const r = b ? b.dataset.rooms : '';
        return r === '' || r === undefined ? '' : (ROOM_NAMES[r] || r);
      }
      case 'price': return range(val('priceMin'), val('priceMax'), mln, '₽');
      case 'area': return range(val('areaMin'), val('areaMax'), null, 'м²');
      case 'floor': return range(val('floorMin'), val('floorMax'), null, 'эт.');
      case 'deadline': return val('filterDeadline');
      case 'kind': {
        const k = activeChip('#kindBtns .kind-btn', 'kind');
        return k ? k.textContent.trim() : '';
      }
      case 'renovation': {
        const r = activeChip('#renovationBtns .renovation-btn', 'renovation');
        return r ? chipText(r) : '';
      }
      default: return '';
    }
  }

  function offerOn(id) {
    const n = document.getElementById(id);
    return !!(n && n.classList.contains('active'));
  }

  /* ЖК выбран ЧЕЛОВЕКОМ, а не назван страницей. На витрине одного ЖК пикер
     стоит на её доме всегда (сброс его не снимает — js/flats.js), и считать это
     «есть что сбрасывать» значило бы держать кнопку видимой на пустом фильтре:
     так и было до 25.09 — после первого же ответа фасетов подпись пикера
     становилась именем дома, и кнопка больше не пряталась. Сверяем ЗНАЧЕНИЕ
     с домом страницы, а не подпись со словом «Все ЖК».                      */
  function projectChosen() {
    const p = document.getElementById('filterBuilding');
    const v = p && p.value ? String(p.value) : '';
    return v !== '' && v !== String(window.BRONI_FLATS_BUILDING_ID || '');
  }

  /* Корпус с генплана (витрина ЖК): его держит flats.js и отдаёт меткой на
     сетке — своего контрола в фильтре у корпуса нет, прочитать его больше
     неоткуда. Без этого при выбранном ТОЛЬКО корпусе «Сбросить» стояла
     скрытой (проверка 25.09, P2-3), и снять корпус из фильтра было нечем. */
  function corpusChosen() {
    return !!grid.dataset.flatsCorpus;
  }

  function projectName() {
    const p = document.getElementById('filterBuilding');
    if (!p || !p.value) return '';
    try {
      const lbl = p.shadowRoot && p.shadowRoot.querySelector('.btn__label');
      return lbl ? lbl.textContent.trim() : '';
    } catch (e) { return ''; }
  }

  function refreshLabels() {
    // Счётчик «Ещё фильтры»: считаем только то, что реально спрятано под ним.
    let hidden = 0;
    MORE_KEYS.forEach((k) => { if (summaryOf(k)) hidden++; });
    if (offerOn('flatsDiscountChip')) hidden++;
    if (offerOn('flatsInstallmentChip')) hidden++;
    if (moreNum) moreNum.textContent = hidden ? String(hidden) : '';
    if (moreBtn) moreBtn.classList.toggle('is-set', hidden > 0);

    // Текст планки телефона.
    const parts = [];
    const cityName = document.querySelector('.flats-city-filter__name');
    if (cityName) parts.push(cityName.textContent.trim());
    STRIP_KEYS.forEach((k) => {
      const s = summaryOf(k);
      if (s) parts.push(s);
    });
    const proj = projectName();
    if (proj && proj !== 'Все ЖК') parts.push(proj);
    if (offerOn('flatsDiscountChip')) parts.push('со скидкой');
    if (offerOn('flatsInstallmentChip')) parts.push('в рассрочку');
    const geo = geoState();
    if (geo.summary) parts.push(geo.summary);
    if (mstripText) {
      mstripText.textContent = parts.length > 1 ? parts.join(' · ') : (parts[0] || 'Все квартиры');
    }

    // «Сбросить» показываем, только когда есть что сбрасывать: пустая кнопка
    // в строке занимает место и обещает действие, которого нет.
    if (resetBtn) {
      const any = hidden > 0 || !!summaryOf('rooms') || !!summaryOf('price')
        || projectChosen() || corpusChosen() || geo.active;
      resetBtn.hidden = !any;
    }
  }

  /** «Метро и районы» (js/flats-geo.js): выбрано ли что-то и короткая подпись для планки. */
  function geoState() {
    const g = window.BroniFlatsGeo;
    try {
      return {
        active: !!(g && typeof g.active === 'function' && g.active()),
        summary: g && typeof g.summary === 'function' ? String(g.summary() || '') : '',
      };
    } catch (e) {
      return { active: false, summary: '' };
    }
  }

  /* ──────────────────────────────────────────────────────────────────────────
     4. КВ-8: РЯД ЧИПОВ СО СЧЁТЧИКАМИ ПОД H1

     ⛔ РЯД ПОГАШЕН СТИЛЕМ (владелец 20.08: «убери дубли») — он повторял ряд
     комнатности фильтра слово в слово и число в число. Узлы всё равно строим:
     соседний черновик витрины дома опирается на селектор `.zkv-hchips`, а
     владелец может вернуть ряд ВМЕСТО фильтра, а не рядом с ним.

     ⛔ ЧИСЛА ЗЕРКАЛЯТСЯ С РОДНЫХ ЧИПОВ ФИЛЬТРА, А НЕ СЧИТАЮТСЯ ЗАНОВО. У
     flats.js своя арифметика («4к+» складывает всё от четырёх комнат) — повтори
     мы её здесь, два ряда с одним смыслом разошлись бы на первом же городе,
     где появятся пятикомнатные. Поэтому наблюдаем за #roomsBtns и переносим
     текст как есть.
     ⛔ Наблюдатель смотрит на #roomsBtns, а пишет в .zkv-hchips — это разные
     поддеревья, петли нет. И пишем только при РЕАЛЬНОМ изменении значения.
     ⛔ Нажатие чипа = клик по РОДНОМУ чипу фильтра. Он статический (сервер
     печатает его в разметке и никогда не пересоздаёт), поэтому клик идёт ровно
     тем же путём, что и клик человека.
     ────────────────────────────────────────────────────────────────────────── */
  const HCHIP_LABELS = { 0: 'Студии', 1: '1-комн', 2: '2-комн', 3: '3-комн', 4: '4-комн+' };

  function buildRoomChips() {
    const box = document.querySelector('.page-hero--flats .container');
    const src = document.getElementById('roomsBtns');
    if (!box || !src || document.querySelector('.zkv-hchips')) return;

    const bar = el('div', 'zkv-hchips');
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Быстрый выбор комнатности');
    const items = [];

    src.querySelectorAll('.room-btn').forEach((real) => {
      const key = real.dataset.rooms || '';
      if (key === '') return;                 // «Все» в ряду под H1 не нужен
      const b = el('button', 'zkv-hchip');
      b.type = 'button';
      b.setAttribute('aria-pressed', 'false');
      b.appendChild(el('span', 'zkv-hchip__t', HCHIP_LABELS[key] || key));
      const num = el('span', 'zkv-hchip__n', '');
      b.appendChild(num);
      b.addEventListener('click', () => real.click());
      bar.appendChild(b);
      items.push({ real: real, node: b, num: num });
    });
    if (!items.length) return;

    box.appendChild(bar);
    syncRoomChips(items);

    if (window.MutationObserver) {
      new MutationObserver(() => syncRoomChips(items)).observe(src, {
        subtree: true, childList: true, characterData: true,
        attributes: true, attributeFilter: ['class'],
      });
    }
  }

  function syncRoomChips(items) {
    items.forEach((it) => {
      const cnt = it.real.querySelector('.room-btn-cnt');
      const txt = cnt ? (cnt.textContent || '').trim() : '';
      // Пишем только при настоящем изменении: лишняя запись дёргала бы
      // наблюдателя вхолостую и мигала бы текстом.
      if (it.num.textContent !== txt) it.num.textContent = txt;
      const on = it.real.classList.contains('active');
      it.node.classList.toggle('is-on', on);
      it.node.setAttribute('aria-pressed', on ? 'true' : 'false');
      // Ноль квартир — чип прячем: клик по нему дал бы пустую выдачу, и это
      // читается как поломка сайта.
      it.node.hidden = it.real.classList.contains('room-btn--empty');
    });
  }

  /* ──────────────────────────────────────────────────────────────────────────
     5. КВ-9: СТРОКА ИТОГА + ЧЕТЫРЕ ВИДА
     ⛔ НЕ ЛИПКАЯ — решение владельца: «пусть плашка за тобой не бегает».
     ────────────────────────────────────────────────────────────────────────── */
  const VIEW_TEXT = {
    grid: ['Плитка', 'Плитка'],
    list: ['Список', 'Список'],
    // 28.09.2026, слово владельца: «на телефоне планы, а на компе планировки — чтоб не
    // путать». Одно слово на любой ширине; место на 390 px даёт flats-showcase.css.
    plans: ['Планировки', 'Планировки'],
  };

  let sumBtn = null;

  function buildResultsBar() {
    const sec = document.querySelector('.flats-toolbar-section');
    const bar = sec && sec.querySelector('.flats-toolbar');
    if (!sec || !bar || sec.classList.contains('zkv-barsec')) return;
    sec.classList.add('zkv-barsec');
    bar.classList.add('zkv-bar');

    foundNode = el('div', 'zkv-found');
    foundNode.setAttribute('role', 'status');
    foundNode.setAttribute('aria-live', 'polite');
    bar.insertBefore(foundNode, bar.firstChild);

    const sort = document.getElementById('flatsSort');
    const views = document.getElementById('flatsViewToggle');
    if (sort) bar.appendChild(sort);
    if (views) bar.appendChild(views);
    if (!views) return;

    // Подписи к прод-кнопкам: у эталона вкладки со словами, а не безымянные
    // значки. Добавляем ВНУТРЬ существующих кнопок — делегат flats.js ищет
    // цель через closest('.view-btn') и находит её по-прежнему.
    views.querySelectorAll('.view-btn').forEach((b) => {
      const pair = VIEW_TEXT[b.dataset.view];
      if (!pair || b.querySelector('.zkv-vlbl--full')) return;
      b.appendChild(el('span', 'zkv-vlbl--full', pair[0]));
      b.appendChild(el('span', 'zkv-vlbl--short', pair[1]));
    });

    // ⛔ ЧЕТВЁРТАЯ ВКЛАДКА БЕЗ КЛАССА .view-btn. flats.js слушает переключатель
    // делегатом по `.view-btn`: поймав нашу кнопку, он увёл бы currentView в
    // значение 'summary', которого не знает, и запросил бы у сервера выдачу,
    // которой нет. Свой класс = свой обработчик, чужой код не задет.
    sumBtn = el('button', 'zkv-vb');
    sumBtn.type = 'button';
    sumBtn.title = 'Сводка';
    sumBtn.setAttribute('aria-pressed', 'false');
    sumBtn.appendChild(icon('fas fa-layer-group'));
    sumBtn.appendChild(el('span', 'zkv-vlbl--full', 'Сводка'));
    sumBtn.appendChild(el('span', 'zkv-vlbl--short', 'Свод'));
    views.insertBefore(sumBtn, views.firstChild);

    sumBtn.addEventListener('click', () => setSummary(!summaryOn));
    // Клик по любому «родному» виду выключает сводку: два подсвеченных вида
    // сразу — это вопрос «а что я сейчас вижу».
    views.addEventListener('click', (e) => {
      if (e.target.closest('.view-btn')) setSummary(false);
    });
    // Кнопка «Назад» возвращает вид через flats.js — сводка обязана уйти
    // вместе с ним, иначе поверх восстановленной выдачи висел бы наш блок.
    window.addEventListener('popstate', () => setSummary(false));
    // Нажатие на генплане ведёт к «Планировкам» корпуса (js/flats.js, 28.09.2026) —
    // «Сводка» поверх них закрыла бы то, куда человека привели.
    document.addEventListener('broni:flats-genplan-plans', () => setSummary(false));

    // Первое значение строки итога: наблюдатель за #flatsCount сработает
    // только на СЛЕДУЮЩЕЙ записи, а до неё строка стояла бы пустой.
    refreshFound();
  }

  function refreshFound() {
    const cnt = document.getElementById('flatsCount');
    const raw = cnt ? (cnt.textContent || '').trim() : '';
    const n = parseInt(raw.replace(/\s+/g, ''), 10);
    const txt = raw === '' || raw === '—' || !isFinite(n) ? '' : nf.format(n);

    if (mstripCount) mstripCount.textContent = raw;
    if (!foundNode) return;

    while (foundNode.firstChild) foundNode.removeChild(foundNode.firstChild);
    if (txt === '') {
      foundNode.appendChild(document.createTextNode('Идёт подбор…'));
      return;
    }
    foundNode.appendChild(document.createTextNode('Найдено '));
    if (lastViewPlans && lastPlansCount !== null) {
      foundNode.appendChild(el('strong', null, nf.format(lastPlansCount)));
      foundNode.appendChild(document.createTextNode(' ' + plansWord(lastPlansCount) + ' · '));
    }
    foundNode.appendChild(el('strong', null, txt));
    foundNode.appendChild(document.createTextNode(' ' + flatsWord(n)));
  }

  /* ──────────────────────────────────────────────────────────────────────────
     6. КВ-5: ЧЕТВЁРТЫЙ ВИД «СВОДКА»
     Эталон — блок «Что есть в продаже» карточки ЖК.

     ⛔ ОТКУДА БЕРУТСЯ ЧИСЛА И ПОЧЕМУ ИМЕННО ОТТУДА.
     У витрины города нет ручки, которая отдала бы разбивку по комнатности
     готовой: `filter_options` знает только СЧЁТЧИКИ и только по городу (цену
     и площадь он не разбивает, а прочие фильтры игнорирует — то есть его
     числа разошлись бы с выдачей, как только включён любой фильтр). Ручка
     `view=plans` пагинирована по 24 карточки из ~600, и первая страница при
     сортировке «дешевле» состоит из ОДНИХ СТУДИЙ — сводка по ней была бы
     враньём (замер 20.08: 24 из 24 карточек rooms=0).

     Поэтому каждая строка считается ТОЧНО, тремя крошечными запросами
     (`per_page=1`) с тем же набором фильтров, что сейчас у выдачи:
       • sort=price_asc  → `total` = сколько квартир, цена САМОЙ ДЕШЁВОЙ и её
                            площадь (настоящая пара для ₽/м²);
       • sort=price_desc → цена самой дорогой (это «до …»);
       • sort=area_asc   → наименьшая площадь (это «от … м²»).
     Сервер сам считает минимум и максимум сортировкой, поэтому цифры точные,
     а не «минимум по видимой странице».

     ⛔ ₽/м² — ЭТО ЦЕНА МЕТРА У САМОЙ ДЕШЁВОЙ КВАРТИРЫ, а не частное двух
     минимумов. Частное `минимальная цена / минимальная площадь` — цена
     НЕСУЩЕСТВУЮЩЕЙ квартиры: самая дешёвая и самая маленькая это разные лоты
     (на карточке ЖК такая формула завышала число на 24-69 %). Здесь обе
     величины взяты у ОДНОГО объекта, и в подписи так и сказано.

     ⛔ ФИЛЬТР КОМНАТНОСТИ СВОДКА НЕ ПРИМЕНЯЕТ — и говорит об этом в шапке.
     Сводка и есть разбивка ПО комнатности; примени она чип «2к», от таблицы
     осталась бы одна строка. Все остальные фильтры применяются полностью.
     ────────────────────────────────────────────────────────────────────────── */

  const DROP_KEYS = ['action', 'view', 'page', 'per_page', 'sort', 'rooms', 'rooms_min'];
  const SUM_BAR_MIN_PCT = 6;
  const SUM_ROW_DELAY_MS = 45;
  const SUM_TILES = 12;

  let summaryOn = false;
  let summaryWrap = null;
  let summaryRowsBox = null;
  let summaryNoteBox = null;
  let summaryRowList = [];
  let plansTog = null;
  let plansTogInput = null;
  let optionRooms = [];
  let sumRunId = 0;
  let sumTimer = null;
  let sumSig = '';

  function rememberOptions(data) {
    if (!data || !data.ok || !Array.isArray(data.rooms)) return;
    optionRooms = data.rooms
      .map((r) => ({ key: parseInt(r.key, 10) }))
      .filter((r) => Number.isInteger(r.key) && r.key >= 0)
      .sort((a, b) => a.key - b.key);
    scheduleSummary();
  }

  function baseParts() {
    return baseQuery.split('&').filter((pair) => {
      if (!pair) return false;
      return DROP_KEYS.indexOf(pair.split('=')[0]) < 0;
    });
  }

  const filterSignature = () => baseParts().slice().sort().join('&');
  const hasBuilding = () => baseParts().some((p) => p.indexOf('building_id=') === 0);

  function apiUrl(extra) {
    // ⛔ view=flats обязателен при выбранном ЖК: без него бэк отдаёт карточки
    // ТИПОВ, а не список квартир, и `total` считает по другому предмету.
    // Это ровно та же развилка, что внутри flats.js.
    const tail = hasBuilding() ? ['view=flats'] : [];
    return '/flat_api.php?action=list&' + baseParts().concat(extra, tail).join('&');
  }

  const roomsTitle = (n) => (n === 0 ? 'Студии' : n + '-комнатные');

  const fmtArea = (a) => {
    const n = parseFloat(a);
    if (!isFinite(n) || n <= 0) return '';
    return (n % 1 === 0 ? n.toFixed(0) : n.toFixed(1)).replace('.', ',');
  };

  function setSummary(on) {
    if (summaryOn === on) return;
    summaryOn = on;
    document.body.classList.toggle('zkv-summary-on', on);
    if (sumBtn) {
      sumBtn.classList.toggle('active', on);
      sumBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    // ⛔ ОТПЕЧАТОК НЕ СБРАСЫВАЕМ. Он и есть кэш: пересчёт стоит пятнадцать
    // запросов, а лимит — 60 в минуту. Сбрасывая его на каждое открытие
    // вкладки, мы тратили бы весь бюджет на четырёх переключениях туда-обратно
    // и получали бы 429 вместо чисел. Если фильтр за это время сменился,
    // buildSummary увидит другой отпечаток и пересчитает сам.
    if (on) scheduleSummary();
  }

  /** Пересчёт откладываем: перетаскивание ползунка даёт залп запросов flats.js,
      и на каждый из них своя сводка была бы залпом ещё из пятнадцати. */
  function scheduleSummary() {
    if (!summaryOn) return;
    window.clearTimeout(sumTimer);
    sumTimer = window.setTimeout(buildSummary, 350);
  }

  /* ── Тумблер «Показать планировки» ───────────────────────────────────────
     Вид и место — как на карточке ЖК (label .fs-tog справа от заголовка).

     ⛔ ОН НЕ УВОДИТ НА ДРУГОЙ ВИД. Раскрывает планировки ПРЯМО В СВОДКЕ;
     отдельный вид «Планировки» живёт своей вкладкой сверху. На эталоне это
     уже ловили: владелец сказал «не могу понять, теперь сводка в планировки
     ведёт».
     ⛔ ПОЧЕМУ ОН РАСКРЫВАЕТ СТРОКИ, А НЕ РИСУЕТ ОБЩУЮ СЕТКУ ПЛАНИРОВОК, как на
     карточке ЖК. У дома планировки приходят одним куском, и общая сетка честна.
     У ГОРОДА их ~600 и они пагинированы по 24: сетка «все планировки города»
     показала бы первую страницу — а это, при сортировке «сначала дешевле»,
     24 студии из 24. Заголовок «планировки» над одними студиями — враньё.
     Поэтому планировки грузятся ПО КОМНАТНОСТИ, то есть внутри строк, где у
     каждой честно написано «показаны 12 из N».                              */
  function makePlansToggle() {
    const lab = el('label', 'zkv-fs-tog');
    const inp = document.createElement('input');
    inp.type = 'checkbox';
    inp.className = 'zkv-fs-tog__i';
    lab.appendChild(inp);
    lab.appendChild(el('span', 'zkv-fs-tog__t'));
    lab.appendChild(el('span', 'zkv-fs-tog__l', 'Показать планировки'));
    inp.addEventListener('change', () => { applyPlansToggle(inp.checked).catch(noop); });
    plansTog = lab;
    plansTogInput = inp;
    return lab;
  }

  async function applyPlansToggle(on) {
    const rows = summaryRowList.filter((r) => !r.node.hidden);
    if (!on) {
      rows.forEach((r) => { if (r.node.classList.contains('is-open')) toggleRow(r); });
      return;
    }
    // По очереди, а не залпом: пять запросов планировок разом бьют в тот же
    // лимит 60/60, что и счёт строк.
    plansTog.classList.add('is-busy');
    try {
      for (const r of rows) {
        if (!plansTogInput.checked) break;      // передумал на середине
        if (!r.node.classList.contains('is-open')) await toggleRow(r);
      }
    } finally {
      plansTog.classList.remove('is-busy');
    }
  }

  function ensureSummaryBox() {
    if (summaryWrap) return summaryWrap;
    const host = document.querySelector('.flats-cards-section .container');
    if (!host) return null;

    summaryWrap = el('div', 'zkv-fs');
    const head = el('div', 'zkv-fs-head');
    head.appendChild(el('div', 'zkv-fs-head__t', 'Что есть в продаже'));
    // ⛔ Честная оговорка на видном месте: числа сводки и число в строке итога
    // разойдутся, как только выбран чип комнатности, — и человек обязан знать
    // почему, а не гадать, какое из двух настоящее.
    head.appendChild(el('div', 'zkv-fs-head__n',
      'Разбивка по комнатности · остальные фильтры учтены'));
    head.appendChild(makePlansToggle());
    summaryWrap.appendChild(head);

    summaryRowsBox = el('div', 'zkv-fs-rows');
    summaryWrap.appendChild(summaryRowsBox);

    summaryNoteBox = el('div', 'zkv-fs-foot');
    summaryWrap.appendChild(summaryNoteBox);

    host.insertBefore(summaryWrap, grid);
    return summaryWrap;
  }

  function buildSummary() {
    if (!summaryOn) return;
    if (!ensureSummaryBox()) return;
    if (baseQuery === '') return;              // ещё не было ни одного запроса

    const sig = filterSignature();
    if (sig === sumSig && summaryRowsBox.childNodes.length) return; // уже посчитано
    sumSig = sig;

    const runId = ++sumRunId;
    const groups = optionRooms.length
      ? optionRooms.map((r) => r.key)
      : [0, 1, 2, 3, 4];                       // фасеты не приехали — обычный набор

    while (summaryRowsBox.firstChild) summaryRowsBox.removeChild(summaryRowsBox.firstChild);
    summaryNoteBox.textContent = '';
    // ⛔ Тумблер гасим на пересчёте. Строки новые, планировки в них ещё не
    // грузились; оставь мы его нажатым — смена фильтра тянула бы за собой ещё
    // пять запросов планировок поверх пятнадцати на счёт, и лимит 60/60
    // кончился бы на третьем движении ползунка.
    if (plansTogInput) plansTogInput.checked = false;

    summaryRowList = groups.map((rooms, i) => {
      const row = makeRow(rooms);
      row.node.style.animationDelay = (i * SUM_ROW_DELAY_MS) + 'ms';
      summaryRowsBox.appendChild(row.node);
      return row;
    });

    fillRows(summaryRowList, runId);
  }

  /** Пустая строка: подпись есть сразу, числа приезжают следом. */
  function makeRow(rooms) {
    const node = el('div', 'zkv-fs-row is-wait');
    const head = el('button', 'zkv-fs-row__head');
    head.type = 'button';
    head.setAttribute('aria-expanded', 'false');

    const left = el('span', 'zkv-fs-row__l');
    const title = el('span', 'zkv-fs-row__t');
    title.appendChild(el('span', null, roomsTitle(rooms)));
    left.appendChild(title);
    const area = el('span', 'zkv-fs-row__a', '…');
    left.appendChild(area);
    const bar = el('span', 'zkv-fs-row__bar');
    const fill = el('i', 'zkv-fs-row__bar-fill');
    fill.setAttribute('aria-hidden', 'true');
    fill.style.width = '0%';
    bar.appendChild(fill);
    left.appendChild(bar);
    head.appendChild(left);

    const right = el('span', 'zkv-fs-row__r');
    const price = el('span', 'zkv-fs-row__price', '…');
    right.appendChild(price);
    const m2 = el('span', 'zkv-fs-row__m2', '');
    right.appendChild(m2);
    head.appendChild(right);

    // Пока число едет — многоточие, а не пустая таблетка: пустой узел выглядел
    // бы серой кляксой без всякого смысла.
    const count = el('span', 'zkv-fs-row__n', '…');
    head.appendChild(count);
    head.appendChild(icon('fas fa-chevron-down', 'zkv-fs-row__c'));
    node.appendChild(head);

    const body = el('div', 'zkv-fs-row__body');
    body.setAttribute('role', 'group');
    body.setAttribute('aria-label', 'Планировки: ' + roomsTitle(rooms));
    const inner = el('div', 'zkv-fs-row__body-in');
    body.appendChild(inner);
    node.appendChild(body);

    const row = {
      rooms: rooms, node: node, head: head, title: title, area: area, fill: fill,
      price: price, m2: m2, count: count, inner: inner, data: null, loaded: false,
    };
    head.addEventListener('click', () => { toggleRow(row).catch(noop); });
    return row;
  }

  /** Три точных замера на группу. Строго по очереди: залп из пятнадцати
      запросов упирается в лимит 60/60 и возвращает 429 вместо чисел. */
  async function fillRows(rows, runId) {
    for (const row of rows) {
      if (runId !== sumRunId) return;
      let d;
      try {
        d = await measure(row.rooms);
      } catch (e) {
        // Отказ сети или лимит запросов: молчим числами, а не выдумываем их.
        if (runId !== sumRunId) return;
        rows.forEach((r) => { if (!r.data) markUnknown(r); });
        summaryNoteBox.textContent = 'Часть чисел не пришла — откройте вкладку ещё раз.';
        // ⛔ Отпечаток стираем, иначе кэш «уже посчитано» запомнил бы прочерки
        // навсегда и повторная попытка была бы невозможна до смены фильтра.
        sumSig = '';
        return;
      }
      if (runId !== sumRunId) return;
      row.data = d;
      if (d.count > 0) applyRow(row, d); else row.node.hidden = true;
      redrawBars(rows);
      redrawFoot(rows);
    }
  }

  function markUnknown(row) {
    row.node.classList.remove('is-wait');
    row.area.textContent = '—';
    row.price.textContent = '—';
    row.m2.textContent = '';
    row.count.textContent = '—';
  }

  async function measure(rooms) {
    const q = (sort) => ['rooms=' + rooms, 'sort=' + sort, 'per_page=1', 'page=1'];
    const cheap = await ask(apiUrl(q('price_asc')));
    const count = parseInt(cheap.total, 10) || 0;
    if (count === 0) return { count: 0 };

    const dear = await ask(apiUrl(q('price_desc')));
    const small = await ask(apiUrl(q('area_asc')));

    const one = (d) => (Array.isArray(d.flats) && d.flats.length ? d.flats[0] : {});
    const cheapFlat = one(cheap);
    const priceMin = parseInt(cheapFlat.price, 10) || 0;
    const cheapArea = parseFloat(cheapFlat.area) || 0;
    return {
      count: count,
      priceMin: priceMin,
      priceMax: parseInt(one(dear).price, 10) || 0,
      areaMin: parseFloat(one(small).area) || 0,
      // Пара цена/площадь ОДНОЙ квартиры — см. докблок раздела.
      m2: priceMin > 0 && cheapArea > 0 ? Math.round(priceMin / cheapArea) : 0,
    };
  }

  function ask(url) {
    if (!nativeFetch) return Promise.reject(new Error('no fetch'));
    return nativeFetch(url, { credentials: 'same-origin' })
      .then((r) => {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then((d) => {
        if (!d || !d.ok) throw new Error('api');
        return d;
      });
  }

  function applyRow(row, d) {
    row.node.classList.remove('is-wait');
    row.node.hidden = false;
    row.area.textContent = d.areaMin > 0 ? 'от ' + fmtArea(d.areaMin) + ' м²' : '—';

    while (row.price.firstChild) row.price.removeChild(row.price.firstChild);
    if (d.priceMin > 0) {
      row.price.appendChild(document.createTextNode('от ' + nf.format(d.priceMin) + ' ₽'));
      if (d.priceMax > d.priceMin) {
        row.price.appendChild(el('span', 'zkv-fs-row__price-to',
          ' · до ' + nf.format(d.priceMax) + ' ₽'));
      }
    } else {
      row.price.appendChild(document.createTextNode('Цену уточняйте'));
    }

    row.m2.textContent = d.m2 > 0 ? nf.format(d.m2) + ' ₽/м²' : '';
    if (d.m2 > 0) row.m2.title = 'Цена метра у самой дешёвой квартиры этого типа';
    row.count.textContent = nf.format(d.count);

    // ⛔ Доступное имя собираем явно: иначе скринридер читает счётчик как
    // хвост цены («…118 000 ₽/м² 4046»), потому что это единственное число
    // без единицы измерения.
    const parts = [roomsTitle(row.rooms)];
    if (d.areaMin > 0) parts.push('от ' + fmtArea(d.areaMin) + ' м²');
    if (d.priceMin > 0) parts.push('от ' + nf.format(d.priceMin) + ' ₽');
    if (d.priceMax > d.priceMin) parts.push('до ' + nf.format(d.priceMax) + ' ₽');
    if (d.m2 > 0) parts.push(nf.format(d.m2) + ' ₽ за метр у самой дешёвой');
    parts.push(d.count + ' ' + flatsWord(d.count));
    row.head.setAttribute('aria-label', parts.join(', '));
  }

  /** Полоска доли считается от самого многочисленного типа. Минимум 6 %:
      иначе одиночная квартира выглядит нулём и строка кажется пустой. */
  function redrawBars(rows) {
    let max = 0;
    rows.forEach((r) => { if (r.data && r.data.count > max) max = r.data.count; });
    let cheapest = null;
    rows.forEach((r) => {
      if (!r.data || !r.data.priceMin) return;
      if (!cheapest || r.data.priceMin < cheapest.data.priceMin) cheapest = r;
    });
    const many = rows.filter((r) => r.data && r.data.count > 0).length > 1;

    rows.forEach((r) => {
      if (!r.data || !r.data.count) return;
      const share = max > 0 ? Math.max(SUM_BAR_MIN_PCT, Math.round(r.data.count / max * 100)) : 0;
      r.fill.style.width = share + '%';
      // Метка «дешевле всего» имеет смысл только при выборе: у единственного
      // типа она сообщала бы, что он дешевле самого себя.
      const want = many && r === cheapest;
      const tag = r.title.querySelector('.zkv-fs-tag');
      if (want && !tag) r.title.appendChild(el('em', 'zkv-fs-tag', 'дешевле всего'));
      if (!want && tag) tag.parentNode.removeChild(tag);
    });
  }

  function redrawFoot(rows) {
    const total = rows.reduce((s, r) => s + (r.data ? r.data.count : 0), 0);
    const done = rows.every((r) => r.data);
    if (total <= 0) {
      summaryNoteBox.textContent = '';
      // Все строки спрятаны — на экране осталась бы одна тихая строчка мелким
      // шрифтом, неотличимая от «ещё считаем». Говорим заметно и один раз.
      if (done && !summaryRowsBox.querySelector('.zkv-fs-note')) {
        const note = el('div', 'zkv-fs-note', 'По этим фильтрам квартир нет — снимите часть условий.');
        note.setAttribute('role', 'status');
        summaryRowsBox.appendChild(note);
      }
      return;
    }
    summaryNoteBox.textContent = (done ? 'Всего ' : 'Посчитано ')
      + nf.format(total) + ' ' + flatsWord(total)
      + ' по текущему фильтру. Нажмите на строку — покажем планировки.';
  }

  /* ── Раскрытие строки: планировки этой комнатности ───────────────────────
     Запрос делаем ТОЛЬКО по клику (или по тумблеру) и ТОЛЬКО один раз на
     строку: сводка ценна тем, что при открытии не грузит ни одной картинки. */
  function toggleRow(row) {
    const open = !row.node.classList.contains('is-open');
    row.node.classList.toggle('is-open', open);
    row.head.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open || row.loaded) return Promise.resolve();
    row.loaded = true;

    const wait = el('div', 'zkv-fs-note', 'Загружаем планировки…');
    wait.setAttribute('role', 'status');
    row.inner.appendChild(wait);

    const url = '/flat_api.php?action=list&'
      + baseParts().concat(['rooms=' + row.rooms, 'view=plans', 'sort=price_asc', 'page=1']).join('&');

    return ask(url).then((d) => {
      while (row.inner.firstChild) row.inner.removeChild(row.inner.firstChild);
      const plans = Array.isArray(d.floorplans) ? d.floorplans : [];
      if (!plans.length) {
        row.inner.appendChild(el('div', 'zkv-fs-note', 'Планировок для этого типа нет.'));
        return;
      }
      const tiles = el('div', 'zkv-fs-row__tiles');
      plans.slice(0, SUM_TILES).forEach((p) => {
        try { tiles.appendChild(planTile(p)); } catch (e) { noop(); }
      });
      row.inner.appendChild(tiles);

      // ⛔ Честно говорим, что показана только часть: сервер отдаёт планировки
      // страницами по 24, и молчание про остаток читалось бы как «это всё».
      // `d.plans` — ПОЛНОЕ число кластеров (бэк считает его до нарезки
      // страницы), а не длина присланного куска.
      const shown = Math.min(plans.length, SUM_TILES);
      const totalPlans = typeof d.plans === 'number' ? d.plans : plans.length;
      if (totalPlans > shown) {
        row.inner.appendChild(el('div', 'zkv-fs-foot',
          'Показаны ' + shown + ' из ' + nf.format(totalPlans) + ' ' + plansWord(totalPlans) + '.'));
      }

      // Переход в полноценный вид: чип комнатности — РОДНОЙ узел разметки, он
      // никогда не пересоздаётся, поэтому клик по нему идёт ровно тем же путём,
      // что и клик человека. Свой обработчик стал бы вторым механизмом.
      const n = row.data ? row.data.count : 0;
      const go = el('button', 'zkv-fs-go', 'Показать все ' + nf.format(n) + ' ' + flatsWord(n) + ' плиткой');
      go.type = 'button';
      go.addEventListener('click', () => {
        const chip = document.querySelector('#roomsBtns .room-btn[data-rooms="' + row.rooms + '"]');
        const gridBtn = document.querySelector('#flatsViewToggle .view-btn[data-view="grid"]');
        setSummary(false);
        if (chip) chip.click();
        if (gridBtn) gridBtn.click();
      });
      row.inner.appendChild(go);
    }).catch(() => {
      while (row.inner.firstChild) row.inner.removeChild(row.inner.firstChild);
      row.inner.appendChild(el('div', 'zkv-fs-note', 'Не удалось загрузить планировки.'));
      row.loaded = false; // дадим попробовать ещё раз
    });
  }

  /** Плитка планировки — справочная, БЕЗ ссылки: своей страницы у планировки
      нет, а вести все плитки на один адрес значит обещать переход, которого
      нет. Название ЖК обязательно: в городской сводке без него плитка не
      отвечает на вопрос «где». */
  function planTile(p) {
    const card = el('div', 'zkv-fs-card');
    const src = typeof p.layout_url === 'string' ? p.layout_url.trim() : '';
    /* ⛔ ДАННЫЕ КЛАДЁМ НА САМУ ПЛИТКУ. Окно крупного плана (соседний черновик
       zadacha-plan-okno, переносится отдельным блоком) читает их отсюда, а не
       вычитывает обратно из текста карточки: разбирать «20,7–24,1 м²» назад в
       числа значит завести второй формат одних и тех же величин, и он
       разойдётся с первым на первом же доме без цены. Плитка кликабельна —
       значит она кнопка, а не картинка. */
    card.tabIndex = 0;
    card.setAttribute('role', 'button');
    if (src) card.dataset.zpoSrc = src;
    if (p.label) card.dataset.zpoLabel = String(p.label);
    if (p.area_min != null) card.dataset.zpoAreaMin = String(p.area_min);
    if (p.area_max != null) card.dataset.zpoAreaMax = String(p.area_max);
    if (p.price_min != null) card.dataset.zpoPriceMin = String(p.price_min);
    if (p.price_max != null) card.dataset.zpoPriceMax = String(p.price_max);
    if (p.count != null) card.dataset.zpoCount = String(p.count);
    if (p.building_name) card.dataset.zpoJk = String(p.building_name);
    if (p.building_id != null) card.dataset.zpoJkId = String(p.building_id);
    if (p.rooms != null) card.dataset.zpoRooms = String(p.rooms);
    if (p.floor_min != null) card.dataset.zpoFloorMin = String(p.floor_min);
    if (p.floor_max != null) card.dataset.zpoFloorMax = String(p.floor_max);
    const box = el('div', 'zkv-fs-card__img' + (src ? '' : ' zkv-fs-card__img--empty'));
    if (src) {
      const img = document.createElement('img');
      img.src = thumbUrl(src, 320);
      img.alt = 'Планировка ' + (p.label || '');
      img.loading = 'lazy';
      img.decoding = 'async';
      box.appendChild(img);
    } else {
      box.appendChild(icon('fas fa-vector-square'));
    }
    card.appendChild(box);

    const lo = parseFloat(p.area_min) || 0;
    const hi = parseFloat(p.area_max) || lo;
    const area = lo > 0
      ? (hi > lo ? fmtArea(lo) + '–' + fmtArea(hi) : fmtArea(lo)) + ' м²'
      : '—';
    card.appendChild(el('div', 'zkv-fs-card__a', area));

    // ⛔ НОЛЬ — ЭТО НЕ ЦЕНА. Планировка без цены выходила бы как «0,0 млн ₽»,
    // то есть обещала бы бесплатную квартиру.
    const pl = parseInt(p.price_min, 10) || 0;
    const ph = parseInt(p.price_max, 10) || pl;
    const mlnTxt = (v) => {
      const m = v / 1e6;
      return (m >= 100 ? String(Math.round(m)) : m.toFixed(1)).replace('.', ',');
    };
    card.appendChild(el('div', 'zkv-fs-card__p', pl > 0
      ? (pl === ph ? mlnTxt(pl) : mlnTxt(pl) + '–' + mlnTxt(ph)) + ' млн ₽'
      : 'Цену уточняйте'));

    const cnt = parseInt(p.count, 10) || 0;
    card.appendChild(el('div', 'zkv-fs-card__n',
      cnt + ' ' + pluralRu(cnt, 'предложение', 'предложения', 'предложений')));

    const jk = String(p.building_name || '').trim();
    if (jk) {
      const node = el('div', 'zkv-fs-card__jk', jk);
      node.title = jk;
      card.appendChild(node);
    }
    return card;
  }

  /* ──────────────────────────────────────────────────────────────────────────
     7. МИНИАТЮРЫ ЧЕРЕЗ /img-thumb.php (нужны плиткам сводки)
     ⛔ Оригиналы фидов весят мегабайты. Правила повторяют public/js/catalog.js:
     кодирование по RFC 3986 (иначе у прокси два файла на один кадр) и своя
     папка только для /img/building_renders (мелкий ассет через прокси стал бы
     ТЯЖЕЛЕЕ оригинала).
     ────────────────────────────────────────────────────────────────────────── */
  const LOCAL_THUMBABLE = /^\/img\/building_renders\/[\w./-]+\.(?:jpe?g|png|webp)$/i;
  const rawUrlEncode = (s) => encodeURIComponent(s)
    .replace(/[!'()*]/g, (c) => '%' + c.charCodeAt(0).toString(16).toUpperCase());

  function thumbUrl(src, w) {
    if (!src || typeof src !== 'string') return '';
    let url = src.trim();
    if (url === '') return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    url = url.replace(/^https?:\/\/(?:www\.)?bronidom\.ru(?=\/)/i, '');
    const width = w || 320;
    if (/^https?:\/\//i.test(url)) return '/img-thumb.php?src=' + rawUrlEncode(url) + '&w=' + width;
    if (LOCAL_THUMBABLE.test(url) && url.indexOf('..') < 0) {
      return '/img-thumb.php?src=' + rawUrlEncode(url) + '&w=' + width;
    }
    return url; // не картинка (svg-заглушка, data:) — отдаём как есть
  }

  /* ──────────────────────────────────────────────────────────────────────────
     8. КВ-1: компактная шапка ГОРОДСКОЙ витрины
     ⛔ САМ ЗАГОЛОВОК ОСТАЁТСЯ ГДЕ СТОИТ — ПОД ФИЛЬТРОМ. У всех четырёх площадок
     H1 тоже ниже панели; решение владельца 20.08. Мы только снимаем фото и
     собираем строку цифр из ЖИВЫХ узлов, которые пишет flats.js.
     ⛔ КРОШКИ НЕ ТРОГАЕМ: строка цифр дописывается в КОНЕЦ контейнера шапки,
     а цепочка стоит первой — её собирает сервер (JkCardBreadcrumbs), и тот же
     массив уходит в BreadcrumbList.
     ────────────────────────────────────────────────────────────────────────── */
  function compactHero() {
    const hero = document.querySelector('.page-hero--flats');
    const box = hero && hero.querySelector('.container');
    const statFlats = document.getElementById('statFlats');
    const statBuildings = document.getElementById('statBuildings');
    const statPrice = document.getElementById('statPriceFrom');
    if (!box || !statFlats) return;

    // Плитки цифр убраны, но САМИ ЧИСЛА остаются: переносим живые узлы в
    // строку. Их по-прежнему обновляет loadStats() из flats.js.
    const line = el('div', 'zkv-counter');
    const put = (text) => { line.appendChild(document.createTextNode(text)); };
    const sep = () => { line.appendChild(el('span', 'zkv-counter__sep', '·')); };

    put('Найдено');
    line.appendChild(statFlats);
    put('квартир в');
    if (statBuildings) line.appendChild(statBuildings);
    put('ЖК');
    if (statPrice) {
      sep();
      put('от');
      line.appendChild(statPrice);
    }
    sep();
    line.appendChild(el('span', 'zkv-counter__free', 'Консультация 0 ₽'));

    box.appendChild(line);
  }

  /* ──────────────────────────────────────────────────────────────────────────
     9. ЗАПУСК
     ⛔ Сборка идёт ПОСЛЕ flats.js и в одном try: любая осечка обязана вернуть
     страницу к родному виду, а не оставить её под маскировкой стиля.
     ────────────────────────────────────────────────────────────────────────── */
  function boot() {
    try {
      decorateAll();
      buildFilterRow();
      buildResultsBar();
      if (!IS_JK_PAGE) compactHero();
      buildRoomChips();
      html.classList.add('zkv-ready');
    } catch (e) {
      // Родная раскладка назад: лучше страница без нового блока, чем страница
      // без фильтра и без выдачи.
      document.body.classList.remove('zkv-city');
      html.classList.add('zkv-broken');
    }
  }

  /* ⛔ ЖДЁМ СОБЫТИЕ, А НЕ СВЕРЯЕМ readyState С 'loading'. Файл подключён с
     defer: во время его исполнения readyState уже 'interactive', и привычная
     проверка выполнила бы сборку НЕМЕДЛЕННО — то есть до flats.js, который
     идёт следующим и только тогда подписывает контролы. DOMContentLoaded
     наступает после ВСЕХ defer-скриптов, поэтому ждём именно его; мгновенный
     путь оставлен только для 'complete' (скрипт подмешали в готовую страницу
     — так делает зеркало приёмки). */
  if (document.readyState === 'complete') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
